export default __webpack_public_path__ + "static/media/feature-b-3.26e4d1b3.jpg";